<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <vx-card>
      <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-5">
              <h6 class="mb-2">Cliente</h6>
              <v-select
              name="customer"
              v-model="customerSelected"
              :options="getCustomersFiltered"
              :loading="isLoadingCustomers"
              :filterable="true"
              :searchable="true"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-validate="'required'"
              placeholder="Digite para buscar (min. 2 caracteres)..."
              @search="onSearchCustomers"
              :no-drop="searchTerm.length > 0 && searchTerm.length < 2"
              :close-on-select="true"
            >
              <template slot="no-options">
                <span v-if="searchTerm.length > 0 && searchTerm.length < 2">
                  Digite pelo menos 2 caracteres
                </span>
                <span v-else-if="isLoadingCustomers">
                  Carregando...
                </span>
                <span v-else>
                  Nenhum cliente encontrado
                </span>
              </template>
            </v-select>
              <br />
              <span class="text-danger">{{ errors.first("customer") }}</span>
            </div>
          </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-1/3 mt-5">
          <h6 class="mb-2">E-mail</h6>
          <vs-input
            name="recipient1"
            v-model="recipient1"
            class="w-full"
            v-validate="'required'"
          />
          <br />
          <span class="text-danger">{{ errors.first("recipient1") }}</span>
        </div>
        <div class="vx-col md:w-1/3 w-1/3 mt-5">
          <h6 class="mb-2">E-mail</h6>
          <vs-input name="recipient2" v-model="recipient2" class="w-full" />
          <br />
        </div>
        <div class="vx-col md:w-1/3 w-1/3 mt-5">
          <h6 class="mb-2">Template</h6>
          <v-select
            name="template"
            v-model="templateSelected"
            :options="templates"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-validate="'required'"
          />
          <br />
          <span class="text-danger">{{ errors.first("template") }}</span>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-full mt-5">
          <vs-list :key="indextr" v-for="(item, indextr) in items">
            <vs-list-item
              :title="item.name"
              :subtitle="item.type"
            ></vs-list-item>
          </vs-list>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/2 mt-5">
          <vs-button class="float-left"  type="filled" color="danger" @click="deleteInvoice" icon-pack="feather" icon="icon-x"
            >Remover</vs-button
          >
        </div>
        <div class="vx-col md:w-1/2 mt-5">
          <vs-button class="float-right" color="success" @click="submit" icon-pack="feather" icon="icon-save"
            >Salvar</vs-button
          >
        </div>
      </div>
    </vx-card>
  </div>
</template>


<script>
import { Validator } from "vee-validate";
import { fileTools } from "@/helpers";
import axios from "axios";
import { baseApiUrl } from "@/global";
import router from "@/router";
import vSelect from "vue-select";
const dict = {
  custom: {
    recipient1: {
      required: "Digite o e-mail",
    },
    template: {
      required: "Selecione o Template",
    },
     customer: {
      required: "Selecione o Cliente",
    },
  },
}; 

Validator.localize("en", dict);
export default {
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      idInvoice : null,
      customerSelected: [],
      recipient1: null,
      recipient2: null, 
      items: [],
      templateSelected: null,
      templates: ["Locação", "Ouro", "Suprimentos", "Mão de Obra"],
      searchTerm: '',
      maxResults: 50,
      minSearchLength: 2,
    };
  },
  computed: {
   // Computed otimizado - agora pega direto do state
   getCustomersFiltered() {
      return this.$store.state.customers.customersFiltered || []
    },
    
    // Novo computed para verificar loading
    isLoadingCustomers() {
      return this.$store.state.customers.isLoading
    },
  },
  methods: {
     // Método debounced para busca otimizada
     onSearchCustomers: _.debounce(async function(search) {
      this.searchTerm = search || ''
      
      try {
        await this.$store.dispatch('customers/searchCustomers', {
          searchTerm: this.searchTerm,
          limit: this.maxResults
        })
      } catch (error) {
        console.error('Erro na busca de clientes:', error)
        this.$vs.notify({
          title: 'Erro',
          text: 'Erro ao buscar clientes. Tentando busca local...',
          color: 'warning'
        })
      }
    }, 300),

    // Método para pré-carregar dados essenciais
    async preloadCustomersData() {
      try {
        const payload = {
          loading: this.$vs.loading,
          idOrder: null,
          typeOrder: this.endpointType,
          idCustomer: this.customerSelected.id,
        }
        
        // Carregar todos os clientes uma vez
        await this.$store.dispatch("customers/fetchCustomersItems", payload)
        
        // Aplicar busca inicial vazia para mostrar primeiros resultados
        await this.$store.dispatch('customers/searchCustomers', {
          searchTerm: '',
          limit: this.maxResults
        })
        
      } catch (error) {
        console.error('Erro ao pré-carregar clientes:', error)
        this.$vs.notify({
          title: 'Aviso',
          text: 'Erro ao carregar lista de clientes',
          color: 'warning'
        })
      }
    },
    async submit() {
      const haveErrors = !(await this.$validator.validateAll());
      if (haveErrors) return;
      let data = {
        idInvoice : this.idInvoice,
        fk_idCustomer: this.customerSelected.id,
        recipient1: this.recipient1,
        recipient2: this.recipient2,
        template: this.templateSelected,
      };
      if(data.fk_idCustomer == null || data.fk_idCustomer == undefined) {
        this.$vs.notify({
          title: "Atenção",
          text: "Selecione um cliente",
          color: "warning",
        });
        return;
      }
      try {
        this.$vs.loading();
        await axios.post(`${baseApiUrl}/invoice/update`, data);
        this.$vs.notify({
          title: "Salvo",
          text: "com Sucesso",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
        router.push("/faturas").catch(() => {});
      } catch (error) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel anexar os arquivos",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      } finally {
        this.$vs.loading.close();
        this.items = [];
      }
    },
    async deleteInvoice(){
      let idInvoice =  this.idInvoice
       try {
        this.$vs.loading();
        await axios.post(`${baseApiUrl}/invoice/delete`,{idInvoice});
        this.$vs.notify({
          title: "Apagado",
          text: "com Sucesso",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
        router.push("/faturas").catch(() => {});
      } catch (error) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel apagar.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  async created() {
    this.fileTools = fileTools();

    let payload = {
      loading: this.$vs.loading,
    };
    await this.preloadCustomersData()
    try {
        this.$vs.loading();
        const response = await axios.get(
          `${baseApiUrl}/invoice/getInvoiceById/${this.$route.params.idInvoice}`
        );
        let customer = {
          id: response.data.invoice[0].fk_idCustomer,
          label:`${response.data.invoice[0].idIlux} |${response.data.invoice[0].corporateName}`,
          corporateName: response.data.invoice[0].corporateName,
        };
        this.customerSelected = customer;
        this.idInvoice = response.data.invoice[0].idInvoice;
        this.templateSelected = response.data.invoice[0].template;
        this.recipient1 = response.data.invoice[0].recipient1
        this.recipient2 = response.data.invoice[0].recipient2
        this.items = response.data.items
        this.$vs.loading.close();
      } catch (error) {
        console.log(error);

        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel carregar " + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }
      finally {
        this.$vs.loading.close();
      }


   // Limpar cache expirado periodicamente
   setInterval(() => {
      this.$store.dispatch('customers/clearExpiredCache')
    }, 5 * 60 * 1000) // A cada 5 minutos
  },
  
  // Limpar intervalos ao destruir componente
  beforeDestroy() {
    // Limpar qualquer timer se necessário
  }
};
</script>

<style scoped>
/* Estilos para melhorar a performance visual */
.vs__dropdown-toggle {
  transition: border-color 0.15s ease-in-out;
}

.vs__dropdown-toggle:focus-within { 
  border-color: #3b82f6;
  box-shadow: 0 0 0 1px #3b82f6;
}

/* Otimizar scroll do dropdown */
.vs__dropdown-menu {
  max-height: 200px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/* Loading state */
.vs__open-indicator {
  transition: transform 0.15s ease;
}
</style>

 
